import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { get, isEmpty } from "lodash";
import Modal from "../../../components/Modal";
import { transformComma } from "../../../utils/validator/comma";
import { dateToViewFormat, monthDayFormat } from "../../../utils/date";
import Button from "../../../components/Button";

const PayStub = ({ list, setList, open, setOpen }) => {
  const { employees } = useSelector((store) => ({
    employees: store.Data.employees,
  }));
  const [employeeInfo, setEmployeeInfo] = useState({});

  useEffect(() => {
    if (!isEmpty(employees)) {
      setEmployeeInfo(
        employees.find((employee) => employee.idx === list.employeeIdx)
      );
    }
  }, [list, employees]);

  const cancel = (e) => {
    e.preventDefault();
    setList({});
    setOpen(false);
  };

  return (
    <Modal isOpen={open} close={cancel}>
      <div className="pay-stub-detail">
        <div className="pay-stub-header-wrap">
          <label className="pay-stub-header-title">급여명세서</label>
          <label className="pay-stub-header-title payMonth">
            {monthDayFormat(dateToViewFormat(get(list, "payFor"), "MM"))}월
          </label>
        </div>
        <div className="pay-stub-body">
          <div className="body-site left">
            <div className="text-wrapper">
              <p className="pay-stub-text">
                안녕하세요. {get(employeeInfo, "name")}님.
              </p>
              <p className="pay-stub-text">
                {get(employeeInfo, "name")}님의{" "}
                {dateToViewFormat(get(list, "payFor"), "YYYY")}년{" "}
                {dateToViewFormat(get(list, "payFor"), "MM")}월 급여명세서
                입니다.
              </p>
              <p className="pay-stub-text">
                귀하의 노고에 진심으로 감사드립니다.
              </p>
            </div>
          </div>
          <div className="body-site right">
            <div className="pay-employee-info-wrap">
              <div className="item-wrap">
                <div className="item">
                  <label className="employee-info-label">부서</label>
                  <span className="employee-info-value">
                    {get(employeeInfo, "partName")}
                  </span>
                </div>
                <div className="item">
                  <label className="employee-info-label">직급</label>
                  <span className="employee-info-value">
                    {get(employeeInfo, "gradeName")}
                  </span>
                </div>
              </div>
              <div className="item-wrap">
                <div className="item">
                  <label className="employee-info-label">직원코드</label>
                  <span className="employee-info-value">
                    {get(employeeInfo, "code")}
                  </span>
                </div>
                <div className="item">
                  <label className="employee-info-label">이름</label>
                  <span className="employee-info-value name">
                    {get(employeeInfo, "name")}
                  </span>
                </div>
              </div>
            </div>
            <div className="pay-info-wrap">
              <div className="label-wrap">
                <p className="pay-info-text">지급계(a)</p>
                <p className="pay-info-text">공제계(b)</p>
                <p className="pay-info-text">차인 지급계(a-b)</p>
              </div>
              <div className="value-wrap">
                <p className="pay-info-text">
                  {transformComma(get(list, "totalAllowance"))}
                </p>
                <p className="pay-info-text">
                  {transformComma(get(list, "totalDeduction"))}
                </p>
                <p className="pay-info-text">
                  {transformComma(get(list, "paymentByDifference"))}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="pay-stub-detail-info">
          <div className="detail-wrap payment">
            <p className="detail-wrap-title">지급내역</p>
            {!isEmpty(get(list, "allowanceList")) &&
              list.allowanceList.map((allowance, idx) => (
                <div className="detail-item" key={idx}>
                  <p className="detail-label">{get(allowance, "name")}</p>
                  <p className="detail-digit">
                    {transformComma(get(allowance, "value"))}
                  </p>
                </div>
              ))}
          </div>
          <div className="vertical-divider" />
          <div className="detail-wrap deduction">
            <p className="detail-wrap-title">공제내역</p>
            {!isEmpty(get(list, "deductionList")) &&
              list.deductionList.filter(data => data.name !== "미제출비과세").map((deduction, idx) => (
                <div className="detail-item" key={idx}>
                  <p className="detail-label">{get(deduction, "name")}</p>
                  <p className="detail-digit">
                    {transformComma(get(deduction, "value"))}
                  </p>
                </div>
              ))}
          </div>
        </div>
        <div className="pay-stub-description-wrap">
          <p className="pay-stub-description-title">안내사항</p>
          <p className="pay-stub-description">{get(list, "description")}</p>
        </div>
        <div className="form-button-wrap">
          <div className="pay-stub-tail">
            <div className="pay-stub-tail-item">
              <label className="pay-stub-tail-title">지급일</label>
              <span className="pay-stub-tail-value">
                {dateToViewFormat(get(list, "payDate"), "YYYY.MM.DD")}
              </span>
            </div>
            <div className="pay-stub-tail-item">
              <label className="pay-stub-tail-title">입금계좌</label>
              <span className="pay-stub-tail-value">
                {get(list, "salaryAccount")}
              </span>
            </div>
          </div>
          
          <div>
          <Button className="form-button print-out" onClick={cancel}>
            확인
          </Button>
          <Button
            className="form-button print-out"
            color="text"
            label="인쇄"
            onClick={() => window.print()}
          />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PayStub;
